export enum NotificationPriority {
    INFO = "INFO",
    IMPORTANT = "IMPORTANT",
    CRITICAL = "CRITICAL"
}